export const MAX_PDF_FILE_SIZE = 26214400; //25MD
export const ALLOWED_FILE_EXT =['gif','jpeg','img', 'png', 'jpg', 'pdf','doc','docx','xls', 'xlsx'];
export const DEFAULT_CATEGORY = 'Select request type';
export const DEFAULT_TYPE = 'Select sub-type';
